import { AspectRatio, Box } from '@chakra-ui/react';
import NextImage from 'next/image';
import { FC } from 'react';

import { ChakraNextResponsiveImage } from '@/components/ui/shared/image/ChakraNextResponsiveImage';
import { ThinEvent } from '@/resources/ThinEvent';

interface IHeaderProps {
  event: ThinEvent;
}

export const Header: FC<IHeaderProps> = ({ event }) => {
  return (
    <Box position="relative">
      <ChakraNextResponsiveImage
        h={{ base: '278px', lg: '360px' }}
        w="full"
        src={event.largeHeaderImageUrl}
        alt={event.name}
        priority
        style={{ objectFit: 'cover' }}
      />
      <ChakraNextResponsiveImage
        src={event.smallLogoUrl}
        w={{ base: '120px', lg: '160px' }}
        h={{ base: '120px', lg: '160px' }}
        alt="Logo"
        position="absolute"
        bottom="-60px"
        left="72px"
        borderRadius="4px"
        border="1px solid"
        borderColor="gray.80"
        sizes="(max-width: 480px) 120px, 160px"
      />
    </Box>
  );
};
